import { ProjectState_Disputed_getInstance3jjamycmvlpib as ProjectState_Disputed_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { color1u2lxyvdop1o6 as color } from './work/payApps/data.mjs';
import { toDoSection277aoqfqgiijq as toDoSection } from '../../theming/banners.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_atStart2tgdnaxgj04ln as get_atStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../sdk/errors.mjs';
import {
  LineItem2rt64afaiyloc as LineItem,
  Incident3aojs8cp7629c as Incident,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Companion_instance3euo5q27joywz as Companion_instance } from './work/scope/LineItemCompletionForm.mjs';
import { navigateOrDialog1m0cnx3luzasq as navigateOrDialog } from '../nav/crowpay.mjs';
import { Companion_instance2o1tmep3w0ant as Companion_instance_0 } from './activity/concerns/IncidentReportForm.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function disputeBar(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var tmp = writer.kbb(shownWhen(writer, VOID, ($this$shownWhen) => $this$shownWhen.daj(_this__u8e3s4.lfy()).u7b_1.equals(ProjectState_Disputed_getInstance()) && $this$shownWhen.daj(_this__u8e3s4.ngj_1)), toDoSection(writer, color(ProjectState_Disputed_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'Project Disputed';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view_0.vb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = content;
  }
  tmp_0.hbu(tmp_1);
  view.hbb(p_0, view_0);
  body(view, 'There is an active dispute in progress. The project has been paused until the dispute is resolved.');
  var dispute = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(_this__u8e3s4.mgz());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp;
      if (element.p5w_1 == null) {
        var tmp0_safe_receiver = element.k5w_1;
        tmp = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l6j_1) === true);
      } else {
        tmp = false;
      }
      if (tmp) {
        destination.v(element);
      }
    }
    var tmp$ret$9;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      var iterator = destination.m1();
      if (!iterator.n1()) {
        tmp$ret$9 = null;
        break $l$block_0;
      }
      var maxElem = iterator.o1();
      if (!iterator.n1()) {
        tmp$ret$9 = maxElem;
        break $l$block_0;
      }
      var it = maxElem;
      var tmp0_safe_receiver_0 = it.o5w_1;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.q60_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.o54_1;
      var maxValue = tmp2_elvis_lhs == null ? it.m5w_1.o54_1 : tmp2_elvis_lhs;
      do {
        var e = iterator.o1();
        var tmp0_safe_receiver_1 = e.o5w_1;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.q60_1;
        var tmp2_elvis_lhs_0 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.o54_1;
        var v = tmp2_elvis_lhs_0 == null ? e.m5w_1.o54_1 : tmp2_elvis_lhs_0;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.n1());
      tmp$ret$9 = maxElem;
    }
    return tmp$ret$9;
  });
  var tmp_2 = view.kbb(get_atStart(view), get_primaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  specCenteredText(view_1, 'Resolve Dispute');
  onClick(view_1, VOID, VOID, disputeBar$slambda_0(dispute, _this__u8e3s4, view_1));
  view.hbb(p_1, view_1);
  view.lbb(tmp_2, view_1);
  writer.hbb(p, view);
  return writer.lbb(tmp, view);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ngz_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var d = tmp_0;
  var tmp1_safe_receiver = d.k5w_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.ogz_1.vgm();
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    // Inline function 'kotlin.collections.find' call
    var tmp0 = tmp_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.mf9_1.equals(tmp1_safe_receiver.j6j_1)) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp0_elvis_lhs_0 = tmp$ret$3;
    var tmp_2;
    if (tmp0_elvis_lhs_0 == null) {
      throw NotFound().pfx(getKClass(LineItem()), null);
    } else {
      tmp_2 = tmp0_elvis_lhs_0;
    }
    var line = tmp_2;
    var tmp_3 = Companion_instance;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.ogz_1.lfy();
    var tmp_4 = await_0(this_2, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var tmp$ret$5 = tmp_4;
    var tmp_5 = tmp_3.egu(line, tmp$ret$5, $this.ogz_1.tgj(), VOID, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    navigateOrDialog($this.pgz_1, tmp_5);
  }
  var tmp2_safe_receiver = d.l5w_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.ogz_1.igt();
    var tmp_6 = await_0(this_3, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    // Inline function 'kotlin.collections.find' call
    var tmp0_0 = tmp_6;
    var tmp$ret$10;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (element_0.b63_1.equals(tmp2_safe_receiver)) {
          tmp$ret$10 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$10 = null;
    }
    var tmp0_elvis_lhs_1 = tmp$ret$10;
    var tmp_7;
    if (tmp0_elvis_lhs_1 == null) {
      throw NotFound().pfx(getKClass(Incident()), null);
    } else {
      tmp_7 = tmp0_elvis_lhs_1;
    }
    var incident = tmp_7;
    var tmp_8 = Companion_instance_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $this.ogz_1.lfy();
    var tmp_9 = await_0(this_4, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    var tmp_10 = tmp_9;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = $this.ogz_1.egt();
    var tmp_11 = await_0(this_5, $completion);
    if (tmp_11 === get_COROUTINE_SUSPENDED())
      tmp_11 = yield tmp_11;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = tmp_11;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s_1 = tmp0_1.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      if (element_1.v67_1.equals(tmp2_safe_receiver)) {
        destination.v(element_1);
      }
    }
    var tmp_12 = tmp_8.xgq(tmp_10, incident, destination, $this.ogz_1.tgj(), $completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
    navigateOrDialog($this.pgz_1, tmp_12);
  }
  return Unit_instance;
}
var disputeBar$slambdaClass;
function disputeBar$slambda() {
  if (disputeBar$slambdaClass === VOID) {
    class $ {
      constructor($dispute, $this_disputeBar, $$this$button) {
        this.ngz_1 = $dispute;
        this.ogz_1 = $this_disputeBar;
        this.pgz_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    disputeBar$slambdaClass = $;
  }
  return disputeBar$slambdaClass;
}
function disputeBar$slambda_0($dispute, $this_disputeBar, $$this$button) {
  var i = new (disputeBar$slambda())($dispute, $this_disputeBar, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  disputeBar as disputeBar3bttgvzigm2w3,
};
//endregion

//# sourceMappingURL=disputeBar.mjs.map
